/* eslint-disable max-len */
import React from "react";

export const ErrorIcon: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24" width="1.2em" height="1.2em">
      <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"></path>
    </svg>
  );
};
